import { PrivateInterceptor } from '../../../Base/interceptors/PrivateInterceptor'


 // GET LISTADO DE ACCESO POR MENU
 export const getAccesosUser = async (idUser) => {
    const result = await PrivateInterceptor('IT/Users/Accesos/'+ idUser, 'GET');
    return result;
 }

// UPDATE LISTADO DE ACCESOS DE UN USUARIO
export const updateAccesoUser = async (data) => {
    const result = await PrivateInterceptor(`IT/Users/Accesos`, 'PUT', data);
    return result;
 }

 export const getPermisoCostosUser = async (idUser) => {
      const result = await PrivateInterceptor('IT/Users/PermisoCostos/'+ idUser, 'GET');
      return result;
 }
 export const getPermisoBotonesUser = async (idUser) => {
      const result = await PrivateInterceptor('IT/Users/PermisosBotones/'+ idUser, 'GET');
      return result;
 }